import { Link } from "react-router-dom";
import FilteredTable from "../pages/Leasing/Renewals/FilteredTable";

export const rentalcontactinfo = [
  {
    value: "Coming Soon 1",
    label: "Coming Soon 1",
  },
  {
    value: "Coming Soon 2",
    label: "Coming Soon 2",
  },
  {
    value: "Coming Soon 3",
    label: "Coming Soon 3",
  },
];

export const guestcsrdassignedto = [
  {
    value: "Unassigned",
    label: "Unassigned",
  },
  {
    value: "Allan Miraflor",
    label: "Allan Miraflor",
  },
  {
    value: "Chris Loney",
    label: "Chris Loney",
  },
  {
    value: "Derek Dorris",
    label: "Derek Dorris",
  },
];
export const contactinfo = [
  {
    value: "kelly s - (405) 888-9090",
    label: "kelly s - (405) 888-9090",
  },
  {
    value: "shanon sepory - (405) 924-9458",
    label: "shanon sepory - (405) 924-9458",
  },
  {
    value: "Star Vick - (405) 609-4507",
    label: "Star Vick - (405) 609-4507",
  },
  {
    value: "michel shall - (405) 439-6082",
    label: "michel shall - (405) 439-6082",
  },
  {
    value: "Tonya Scales - (405) 201-7193",
    label: "Tonya Scales - (405) 201-7193",
  },
];

export const Propertiesunitscampaigns = [
  "test1 - 912 n creek dr  edmond, OK 73034",
  "test2 - 912 n creek dr  edmond, OK 73034 - $0.00",
  "test3 - 1800 canyon park circle  edmond, OK 73013",
  "test4 - 912 n creek dr  edmond, OK 73034 - $0.00",
  "test 5 - 1800 canyon park circle  edmond, OK 73013 - $0.00",
];
export const Renwalstatus = [
  "Eligible",
  "Pending",
  "Completed",
  "Preared not Sent",
  "Renewal Offer Started",
  "Not Eligible",
];

export const filtersdData = [
  {
    key: "1",
    propertyUnit: "1500 NE 43rd St",
    tenants: "William Sunken",
    expiration: "--",
    currentRent: "$725.00",
    newRent: "$725.00",
    status: "Eligible",
  },
];


